'use strict'

const FILE_ACCESS_CAMELCASE = "fileAccess";
const FILE_UPLOAD_DEF_PATH_FETCH_REQUEST = "FILE_UPLOAD_DEF_PATH_FETCH_REQUEST";
const FILE_UPLOAD_DEF_PATH_FETCH_SUCCESS = "FILE_UPLOAD_DEF_PATH_FETCH_SUCCESS";
const FILE_UPLOAD_DEF_PATH_FETCH_FAILURE = "FILE_UPLOAD_DEF_PATH_FETCH_FAILURE";
const FILE_UPLOAD_DIR_LIST_FETCH_REQUEST = "FILE_UPLOAD_DIR_LIST_FETCH_REQUEST";
const FILE_UPLOAD_DIR_LIST_FETCH_SUCCESS = "FILE_UPLOAD_DIR_LIST_FETCH_SUCCESS";
const FILE_UPLOAD_DIR_LIST_FETCH_FAILURE = "FILE_UPLOAD_DIR_LIST_FETCH_FAILURE";
const FILE_UPLOAD_SET_ABS_PATH = "FILE_UPLOAD_SET_ABS_PATH";
const FILE_UPLOAD_UPDATE_ABS_PATH = "FILE_UPLOAD_UPDATE_ABS_PATH";
const FETCH_FILES_FROM_DEVICE_REQUEST = "FETCH_FILES_FROM_DEVICE_REQUEST";
const FETCH_FILES_FROM_DEVICE_SUCCESS = "FETCH_FILES_FROM_DEVICE_SUCCESS";
const FETCH_FILES_FROM_DEVICE_FAILURE = "FETCH_FILES_FROM_DEVICE_FAILURE";
const FETCH_FILES_FROM_DEVICE_ON_BTN_CLICKED = "FETCH_FILES_FROM_DEVICE_ON_BTN_CLICKED";
const DIR_LIST_ERR_MODAL_CONTROL = "DIR_LIST_ERR_MODAL_CONTROL";
const FILE_UPLOAD_RESET_FAILURE = "FILE_UPLOAD_RESET_FAILURE";
const FILE_UPLOAD_DEVICE_STATE_ADD = 'FILE_UPLOAD_DEVICE_STATE_ADD';
const FILE_UPLOAD_DEVICE_STATE_REMOVE = 'FILE_UPLOAD_DEVICE_STATE_REMOVE';

const INITIAL_DIR_LISTING_SKIP = 0;
const INITIAL_DIR_LISTING_TAKE = 500;

export{
    FILE_ACCESS_CAMELCASE,
    FILE_UPLOAD_DEF_PATH_FETCH_REQUEST,
    FILE_UPLOAD_DEF_PATH_FETCH_SUCCESS,
    FILE_UPLOAD_DEF_PATH_FETCH_FAILURE,
    FILE_UPLOAD_DIR_LIST_FETCH_REQUEST,
    FILE_UPLOAD_DIR_LIST_FETCH_SUCCESS,
    FILE_UPLOAD_DIR_LIST_FETCH_FAILURE,
    FILE_UPLOAD_SET_ABS_PATH,
    FETCH_FILES_FROM_DEVICE_REQUEST,
    FETCH_FILES_FROM_DEVICE_SUCCESS,
    FETCH_FILES_FROM_DEVICE_FAILURE,
    FETCH_FILES_FROM_DEVICE_ON_BTN_CLICKED,
    FILE_UPLOAD_UPDATE_ABS_PATH,
    DIR_LIST_ERR_MODAL_CONTROL,
    FILE_UPLOAD_RESET_FAILURE,
    FILE_UPLOAD_DEVICE_STATE_ADD,
    FILE_UPLOAD_DEVICE_STATE_REMOVE,
    INITIAL_DIR_LISTING_SKIP,
    INITIAL_DIR_LISTING_TAKE
}